import Wallet from './Wallet.vue'

export {
    Wallet
}